import * as Actions from '../actions';

export default function initialiseSettingsReducer(state = {}, action) {
	switch (action.type) {		
		case Actions.INITIALISE_SETTINGS_COMPLETE:
			return { ...action.settings };
		case Actions.LOAD_SYNONYMS_COMPLETE:
			return { ...state, ...{ synonyms: action.synonyms } };
		default:
			return state;
	}
}
